const isLoading = true;

export default isLoading;



// WEBPACK FOOTER //
// ./app/data/isLoading.js